import { BaseService } from "@js/filesfromccqbase/BaseService";
import { BroadcastService } from "@js/filesfromccqbase/BroadcastService";
import {
  BuildProcurementTypeEnum,
  DevelopmentFinanceDeal,
  ExitStrategyEnum,
  LoanCompletionTypeEnum,
  OwnOrPurchaseEnum,
  PlanningPermissionTypeEnum,
  PlanningResponsibilityEnum,
  ProductFamilyEnum,
  ProductTypeEnum,
  PropertyTypeEnum,
  SaveDevFinanceSearchRequest,
  TimeLeftOnLeaseEnum,
  UpdateDevFinanceSearchGetResultRequest,
  UpdateDevFinanceSearchGetResultResponse,
} from "@src/apis/ModularClient";

export class DevFinanceDealService extends BaseService<DevelopmentFinanceDeal, number> {
  static $inject = ["$http", "$cookies", "$rootScope", "$q", "$timeout", "BroadcastService"];

  constructor(
    http: ng.IHttpService,
    cookies: ng.cookies.ICookiesService,
    rootScope: ng.IRootScopeService,
    q: ng.IQService,
    timeout: ng.ITimeoutService,
    broadcastservice: BroadcastService,
  ) {
    super(http, cookies, rootScope, q, timeout, broadcastservice);
    this.$baseAddress = "/api/devfinancedeal";
    this.$broadcastBusinessNameSingular = "devfinancedeal";
    this.$broadcastBusinessNamePlural = this.$broadcastBusinessNameSingular + "s";
    this.$broadcastScreen = this.$broadcastBusinessNamePlural;
  }

  debugSearch(dealDto: DevelopmentFinanceDeal): ng.IPromise<[]> {
    let defer = this.$q.defer<[]>();
    this.$http
      .get(this.$baseAddress + "/debugSearch")
      .then((response) => {
        defer.resolve(response.data as []);
      })
      .catch((response) => {
        defer.reject(response);
      });
    return defer.promise;
  }

  clearSearchdata(dealDto) {
    let tempDealDto = { ...dealDto };
    dealDto = {} as DevelopmentFinanceDeal;
    dealDto.Id = tempDealDto.Id;
    dealDto.HasIsFamilyInResidence = tempDealDto.HasIsFamilyInResidence;
    dealDto.IsFamilyInResidence = tempDealDto.IsFamilyInResidence;
    dealDto.PropertyAddress = tempDealDto.PropertyAddress;
    dealDto = this.initialDataSetUpForDeal(dealDto);
    return dealDto;
  }

  initialDataSetUpForDeal(dealDto: DevelopmentFinanceDeal) {
    dealDto.maxLoanRequired = true;
    dealDto.productType = ProductTypeEnum.Development;
    dealDto.productFamily = ProductFamilyEnum.Development;
    dealDto.ownOrPurchase = OwnOrPurchaseEnum.Purchasing;
    dealDto.endPropertyType = PropertyTypeEnum.Residential;
    dealDto.loanCompletionType = LoanCompletionTypeEnum.JustCheckingMyOptions;
    dealDto.showLenderInfoBrokerOverride = true;
    dealDto.hasPostcode = true;
    dealDto.planningStatusAtEndOfLoan = PlanningPermissionTypeEnum.DetailedPlanning;
    dealDto.planningResponsibility = PlanningResponsibilityEnum.Borrower;
    dealDto.buildProcurementType = BuildProcurementTypeEnum.TraditionalContract;
    dealDto.exitStrategy = ExitStrategyEnum.Sale;
    dealDto.hasOwnOrPurchase = false;

    return dealDto;
  }

  datasetupOnOwnOrPurchaseChange(dealDto: DevelopmentFinanceDeal) {
    if (dealDto.ownOrPurchase != null && dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
      dealDto.originalPurchaseDate = null;
      dealDto.currentvalue = null;
      dealDto.landTotalOtherCosts = 0;
    }

    if (dealDto.ownOrPurchase != null && dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own) {
      dealDto.purchaseCosts = 0;
      dealDto.doYouOwnTheProperty = true;
    }
    return dealDto;
  }

  datasetupOnIsTenantedBuildingChange(dealDto: DevelopmentFinanceDeal) {
    if (!dealDto.isTenantedBuilding) {
      dealDto.numberOfTenancies = null;
    }
    return dealDto;
  }
}
